import { NavLink, Outlet, useParams } from "react-router-dom";
import type { FunctionComponent } from "react";

export const ProposalAdminPartial: FunctionComponent = () => {
  const { proposalId } = useParams();

  const menuList = [
    {
      name: "Campaign details",
      link: "campaign-details",
    },
    {
      name: "Creator list",
      link: "creator-list",
    },
  ];

  return (
    <div className="relative flex flex-col w-full h-screen">
      <div className="flex flex-col w-full">
        <div className="top-0 z-20 sticky flex justify-between items-center bg-gradient-to-b from-background via-background to-transparent px-6 pl-8 w-full h-32">
          <p className="font-semibold text-2xl">Create proposal</p>
          <div className="flex justify-between items-center border border-border rounded-lg w-fit overflow-hidden">
            <ul className="flex justify-between items-center w-full font-semibold">
              {menuList.map((menu) => {
                const isCreatorList = menu.link === "creator-list";
                const shouldDisable = isCreatorList && !proposalId;

                return shouldDisable ? (
                  <li
                    key={menu.link}
                    className="flex justify-center items-center opacity-50 px-6 border border-transparent rounded-lg h-14 text-secondary cursor-not-allowed"
                  >
                    {menu.name}
                  </li>
                ) : (
                  <NavLink
                    to={menu.link}
                    key={menu.link}
                    className={({ isActive }) =>
                      `px-6 h-14 flex items-center justify-center border border-transparent text-secondary rounded-lg ${isActive ? "border border-white text-white" : ""}`
                    }
                  >
                    {menu.name}
                  </NavLink>
                );
              })}
            </ul>
          </div>
        </div>

        <Outlet />
      </div>
    </div>
  );
};
